import { render } from "./SenderInformation.vue?vue&type=template&id=2d426a43"
import script from "./SenderInformation.vue?vue&type=script&lang=js"
export * from "./SenderInformation.vue?vue&type=script&lang=js"

import "./SenderInformation.vue?vue&type=style&index=0&id=2d426a43&lang=css"

import exportComponent from "../../../../../../../../../../Users/karimdmai2026/Eurekali-Souverainete/eurekali-b2c/eurekalifront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__